import React from 'react';
import { Target, Zap, Users } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="relative py-32 px-6" data-testid="about-section">
      <div className="max-w-6xl mx-auto">
        <div className="section-divider mb-20"></div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div data-aos="fade-right">
            <h2 className="text-4xl font-bold mb-6" data-testid="about-title">About Jupiter Cosmic</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>
                Jupiter Cosmic is a forward-thinking IT solutions company focused on delivering intelligent, scalable, and high-performance digital systems.
              </p>
              <p>
                We combine strategy, engineering, and innovation to create technology that drives measurable business impact.
              </p>
              <p>
                From startups to enterprises, we transform ideas into reliable digital ecosystems built for long-term growth.
              </p>
            </div>
            
            <div className="grid grid-cols-3 gap-6 mt-10">
              <div className="text-center">
                <div className="text-3xl font-bold text-[#00E5FF]">10+</div>
                <div className="text-sm text-gray-400 mt-1">Projects</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#00E5FF]">10+</div>
                <div className="text-sm text-gray-400 mt-1">Clients</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#00E5FF]">2+</div>
                <div className="text-sm text-gray-400 mt-1">Years</div>
              </div>
            </div>
          </div>
          
          <div data-aos="fade-left" className="relative">
            <div className="glass-card p-8 space-y-6">
              <div className="flex items-start space-x-4">
                <div className="p-3 rounded-lg bg-[#00E5FF]/10">
                  <Target className="w-6 h-6 text-[#00E5FF]" />
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Strategic Vision</h3>
                  <p className="text-sm text-gray-400">Aligning technology with business goals</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="p-3 rounded-lg bg-[#00E5FF]/10">
                  <Zap className="w-6 h-6 text-[#00E5FF]" />
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Rapid Execution</h3>
                  <p className="text-sm text-gray-400">Fast delivery without compromising quality</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="p-3 rounded-lg bg-[#00E5FF]/10">
                  <Users className="w-6 h-6 text-[#00E5FF]" />
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Expert Team</h3>
                  <p className="text-sm text-gray-400">Seasoned professionals across all domains</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
